export const MINIMUM_ORDER_AMOUNT = 499 // 499 kr
export const EXTRA_FEE = 139 // 139 kr

export const DEFAULT_PRODUCT_FILTER_RANGE = [0, 200000] as [number, number]
